import { noop } from "lodash";
import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Form } from "../../components/forms";
import { EditableField } from "../../components/forms/field";
import { useAppLoader } from "../../components/loader/app-loader-hook";
import { Widget } from "../../components/widget";
import { AppStore } from "../../store";
import { AuthDTO } from "../../store/auth/models/dto";
import { AuthService } from "../../store/auth/service";
import {
  Fetchable,
  isFetchableSuccess,
} from "../../store/common/fetchable/helpers";
import { useYupValidationResolver } from "../../utils/utils";
import { CTA, StyledPassword } from "../profile/base";

type RequestDTO = AuthDTO.Requests.ResetPassword.T;

export const ResetPassword: React.FunctionComponent<{}> = () => {
  const { labels, validation } = AuthDTO.Requests.ResetPassword.useFields();
  const resolver = useYupValidationResolver(validation);
  const loader = useAppLoader();
  const auth = useSelector<AppStore, Fetchable<AuthDTO.Responses.Login.T>>(
    (store) => store.auth.login
  );

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<RequestDTO>({
    resolver,
    defaultValues: AuthDTO.Requests.ResetPassword.defaults,
  });

  return (
    <Widget title="Change Password">
      <Form
        onSubmit={handleSubmit((data) => {
          if (isFetchableSuccess(auth)) {
            loader(
              AuthService.resetPassword(
                auth.data.accessToken.originalUser?.type === "DELEGATE"
                  ? auth.data.accessToken.originalUser.id
                  : auth.data.accessToken.credentialsId,
                data
              ).catch(noop)
            );
            reset();
          }
        })}
      >
        <div>
          <EditableField editing control={control} name="currentPassword">
            <StyledPassword
              fullWidth
              obfuscating
              label={labels.currentPassword}
              error={!!errors.currentPassword}
              helperText={errors.currentPassword?.message}
              autoComplete="password"
            />
          </EditableField>
          <EditableField editing control={control} name="newPassword">
            <StyledPassword
              fullWidth
              obfuscating
              label={labels.newPassword}
              error={!!errors.newPassword}
              helperText={errors.newPassword?.message}
              autoComplete="new-password"
            />
          </EditableField>
          <EditableField editing control={control} name="confirmPassword">
            <StyledPassword
              fullWidth
              obfuscating
              label={labels.confirmPassword}
              error={!!errors.confirmPassword}
              helperText={errors.confirmPassword?.message}
              autoComplete="new-password"
            />
          </EditableField>
        </div>
        <CTA>Save</CTA>
      </Form>
    </Widget>
  );
};
